import React from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft } from "react-icons/md";
import MarketplaceMembership from "../MarketplaceMembership/MarketplaceMembership";
import { useState } from "react";
import { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { getBusinessSwitched } from "../../Utils/LocalStorage";
const MyProfileMarketMembershipPage = () => {
  const [currentTab, setcurrentTab] = useState("");

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "marketplace-membership") {
      setcurrentTab("marketplacemembership");
    }
  }, []);

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/dashboard"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Profile</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink to={"/my-profile/general-info"} className={"tabs_li"}>
                General Info
              </NavLink>
              <NavLink to={"/my-profile/business-info"} className={"tabs_li"}>
                Business Info
              </NavLink>
              <NavLink to={"/my-profile/store-info"} className={"tabs_li"}>
                Store Info
              </NavLink>
              <NavLink to={"/my-profile/subscription"} className={"tabs_li"}>
                Subscription
              </NavLink>
              {/* <NavLink to={"/my-profile/bank-info"} className={"tabs_li"}>
                Bank Info
              </NavLink> */}
              {/* <NavLink
                to={"/my-profile/transaction-history"}
                className={"tabs_li"}
              >
                Transaction History
              </NavLink> */}
              <NavLink
                className={
                  currentTab === "marketplacemembership"
                    ? " activeTab"
                    : "tabs_li"
                }
              >
                Marketplace Membership
              </NavLink>
              {getBusinessSwitched() === "false" && (
                <NavLink to="/my-profile/manage-business" className={"tabs_li"}>
                  Manage Businesses
                </NavLink>
              )}
            </div>
            <div className="mt-3">
              <MarketplaceMembership />
            </div>

            {/* <Tabs
              defaultActiveKey="general-info"
              id="uncontrolled-tab-example"
              className="mb-3 my-account"
            >
              <Tab eventKey="general-info" title="General Info">
                <MyProfileGeneralInfo />
              </Tab>
              <Tab eventKey="business-info" title="Business Info">
                <MyProfileBusinessInfo />
              </Tab>
              <Tab eventKey="store-info" title="Store Info">
                {storeInfoFlag === true ? (
                  <EditNewLocation RefreshFlagfunc={RefreshFlagStore} />
                ) : (
                  <AddNewLocation />
                )}
              </Tab>
              <Tab eventKey="bank-info" title="Bank Info">
                {bankInfoFlag === true ? (
                  <MyProfileAddBankInfo RefreshFlagfunc={RefreshFlag} />
                ) : (
                  <MyProfileEditBankInfo />
                )}
              </Tab>
              <Tab eventKey="transaction-history" title="Transaction History">
                <TransactionHistory />
              </Tab>
              <Tab
                eventKey="marketplace-membership"
                title="Marketplace Membership"
              >
                <MarketplaceMembership />
              </Tab>
            </Tabs> */}
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default MyProfileMarketMembershipPage;
